window.EsriRoutingHelper = class EsriRoutingHelper {
    // DOCUMENTATION: JavaScript API routeTask: https://developers.arcgis.com/labs/javascript/get-a-route-and-directions/
    // DOCUMENTATION: REST API routeTask: https://developers.arcgis.com/rest/network/api-reference/route-synchronous-service.htm
    // Note to developers: either use the REST API or the JS API routeTask (wrapper of the REST API) to get the route

    constructor(credentials) {
        this.credentials = credentials;
    }
    
    async calculateRoute (stops) {
        const { access_token } = await this._getToken();
        return await this._getRoute(access_token, stops);
    }

    _getToken () {
        const params = {
            client_id: this.credentials.clientId,
            client_secret: this.credentials.clientSecret,
            grant_type: 'client_credentials'
        };
        const url = `https://www.arcgis.com/sharing/rest/oauth2/token?${$.param(params)}`;

        return fetch(url).then(response => response.json());
    }

    _getRoute (token, stops) {
        const params = {
            token,
            f: 'json',
            startTime: Date.now(),   // specifying startTime to now will use live traffic info
            startTimeIsUTC: true,
            stops: JSON.stringify({
                type: 'features',
                features: stops
            })
        };

        const url = `https://route.arcgis.com/arcgis/rest/services/World/Route/NAServer/Route_World/solve?${$.param(params)}`;
        return fetch(url).then(response => response.json());
    }
}